import { useState } from 'react'
import { useFormContext } from 'react-hook-form'
import { HealthControlForm } from 'src/@types/validations/Animal'
import { toast } from 'react-toastify'
import { toastSyncSuccess } from 'src/utils/syncToast'
import { useCreateAnimalVaccineHistoric } from 'src/hooks/api/animal/mutations/useCreateAnimalVaccineHistoric'
import { CreateVaccineHistoryDto } from 'src/dto/animal.dto'
import { useGetVaccineList } from 'src/hooks/api/vaccine'
import { useAuth } from 'src/contexts/auth'
import { defaultFormValues } from '..'

export const useHealthControl = () => {
  const { userFarm: farmId } = useAuth()

  const [isSaving, setIsSaving] = useState(false)
  const { reset } = useFormContext<HealthControlForm>()

  const { mutateAsync: createAnimalVaccineHistoric } = useCreateAnimalVaccineHistoric()
  const { data: vacineList } = useGetVaccineList()

  const registerMedications = async (animalId: string, formData: HealthControlForm) => {
    try {
      const medicadion = vacineList?.filter((vacine) => formData.vacinas.includes(vacine.idVacina))
      for (const vacine of medicadion || []) {
        const medicationData: CreateVaccineHistoryDto = {
          idVacina: vacine.idVacina!,
          dose: vacine.data.dose!,
          descricao: vacine.data.descricao!,
          dataAplicacao: formData.dataAplicacao!,
          idAnimal: animalId,
          idFazenda: farmId!
        }
        await createAnimalVaccineHistoric(medicationData)
      }
    } catch (error) {
      toast.error('Erro ao salvar vacinas')
      console.error('Error during animal vaccination:', error)
    }
  }

  const onSubmit = async (formData: HealthControlForm) => {
    setIsSaving(true)

    if (formData.tipoControle === 'animal') {
      await registerMedications(formData.idAnimal!, formData)
      reset(defaultFormValues)
      setIsSaving(false)
      toastSyncSuccess('Vacinas salvas com sucesso')
      return
    }

    if (!formData.animais.length || !formData.vacinas.length) {
      setIsSaving(false)
      return
    }

    await Promise.all(formData.animais.map((animalId) => registerMedications(animalId, formData)))

    reset(defaultFormValues)
    setIsSaving(false)
    toastSyncSuccess('Vacinas salvas com sucesso')
  }

  return {
    isSaving,
    onSubmit
  }
}
